import React from "react";
import "./index.css";
import App from "./App";
import ReactDOM from "react-dom";

ReactDOM.render(<App />, document.getElementById("root"));
